import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { NewCommentProps } from './NewComment';

export const LazyNewComment: FunctionComponent<NewCommentProps> = (props) => {
  const NewComment = useLazyComponent(
    () => import(/* webpackChunkName: "new-comment" */ './NewComment'),
    { namedImport: 'NewComment' },
  );

  return (
    <ErrorBoundary tags={{ ownershipArea: 'trello-aaaa', feature: 'Comments' }}>
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <NewComment {...props} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
